import {
    LandingPagesOccupationBeats,
    LANDING_PAGES_OCCUPATION_BEATS_NUMBER_OF_PAGES,
    SEO_RESULTS_PER_PAGE,
    SEO_URL_LANDING_PAGE_PREFIX
} from "@authory-packages/seo-static-data";
import { PanelLink } from "../../../../components/MarketingCarouselCategories";
import { ExamplesPageLayout } from "../../../../pagelayouts/examples";
import { APPLICATION_ROUTES } from "../../../../shared-logic/routes";

const ExampleJobPage = ({ panelLinks, pageNumber }: { panelLinks: PanelLink[]; pageNumber: number }) => (
    <ExamplesPageLayout
        title={<>TBD</>}
        description={<>TBD</>}
        panelLinks={panelLinks}
        categoriesLinks={[]}
        masonryItems={{ users: [] }}
        ogTitle={"TBD"}
        ogDescription={"TBD"}
        embedConf={[]}
        pagination={{
            page: pageNumber,
            limit: SEO_RESULTS_PER_PAGE,
            pages: LANDING_PAGES_OCCUPATION_BEATS_NUMBER_OF_PAGES,
            total: LandingPagesOccupationBeats.length,
            prev: pageNumber === 1 ? null : pageNumber - 1,
            next: pageNumber + 1 < LANDING_PAGES_OCCUPATION_BEATS_NUMBER_OF_PAGES ? pageNumber + 1 : null
        }}
        paginationURL={APPLICATION_ROUTES.USE_CASES_PROFESSION_CATEGORIES}
        faq={[]}
    />
);

export async function getStaticPaths() {
    let paths: { params: { page: string } }[] = [];

    if (process.env.EXAMPLES_PAGES_PIPELINE) {
        for (let pageIndex = 1; pageIndex <= LANDING_PAGES_OCCUPATION_BEATS_NUMBER_OF_PAGES; pageIndex++) {
            paths.push({ params: { page: pageIndex.toString() } });
        }
    }

    return { paths, fallback: false };
}

export async function getStaticProps(ctx: any) {
    const page = ctx.params.page as string;
    const pageNumber = parseInt(page);
    const begin = (pageNumber - 1) * SEO_RESULTS_PER_PAGE;
    const end = Math.min(pageNumber * SEO_RESULTS_PER_PAGE, LandingPagesOccupationBeats.length);

    const panelLinks = LandingPagesOccupationBeats.slice(begin, end).map((occ) => ({
        url: `${APPLICATION_ROUTES.USE_CASES}/${SEO_URL_LANDING_PAGE_PREFIX}${occ.key}`,
        label: occ.occupation
    }));

    return {
        props: {
            panelLinks,
            pageNumber
        }
    };
}

export default ExampleJobPage;
